import React from 'react'
import { Link } from 'gatsby'
import { Container, Row, Col } from 'react-bootstrap'

import LogoMark from './logo-mark'
import Heart from '../images/ohio.svg'
import LinkedInWhite from '../images/social/linkedin-white.svg'
import GitHubWhite from '../images/social/github-white.svg'
import TwitterWhite from '../images/social/twitter-white.svg'
import StackoverflowWhite from '../images/social/stackoverflow-white.svg'

const Footer = () => (
  <Container as="footer" className="footer">
    <Row>
      <Col xs={12} sm={8} md={6} className="mb-4 mb-md-0">
        <Link to="/">
          <LogoMark />
        </Link>

        <p className="sosume">
          &copy; 2021 <Link to="/">Chris Peters</Link>.
        </p>
        <p className="sosume">
          Made with <Heart /> in Ohio.
        </p>
      </Col>

      <Col xs={12} sm={4} md={6} className="text-sm-right">
        <a
          href="https://www.linkedin.com/in/chrisdpeters/"
          className="social"
          title="LinkedIn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LinkedInWhite />
        </a>

        <a
          href="https://github.com/chrisdpeters"
          className="social"
          title="GitHub"
          target="_blank"
          rel="noopener noreferrer"
        >
          <GitHubWhite />
        </a>

        <a
          href="https://twitter.com/chrisdpeters"
          className="social"
          title="Twitter"
          target="_blank"
          rel="noopener noreferrer"
        >
          <TwitterWhite />
        </a>

        <a
          href="https://stackoverflow.com/users/175981/chris-peters"
          className="social"
          title="Stack Overflow"
          target="_blank"
          rel="noopener noreferrer"
        >
          <StackoverflowWhite />
        </a>
      </Col>
    </Row>
  </Container>
)

export default Footer
